const editSchema = {
	group: "block",
	attrs: { src: { default: null }, title: { default: null }, width: { default: null }, height: { default: null } },
};

export default editSchema;
